import $ from 'jquery';

function initControl(el, observe, not) {
	observe = $(observe).get(0);
	var radioList = $(observe.form.elements[observe.name]);

	function update() {
		el.hidden = not ? observe.checked : !observe.checked;
	}

	radioList.on('change', update);
	update();
}

function initRequiredSelect(el, observe, not) {
	observe = $(observe).get(0);

	var select = $(observe.form).find(observe).closest('select');
	
	function update() {
		$(el).siblings('.b-form-label').toggleClass('b-form-label_required', observe.selected);
		el.required = not ? !observe.selected : observe.selected;
	}

	select.on('change', update);
	update();
}

$.addInit(function(context){
	$('[data-if]', context).each(function(){
		initControl(this, $(this).data('if'), false);
	});

	$('[data-if-not]', context).each(function(){
		initControl(this, $(this).data('if-not'), true);
	});

	$('[data-required-if]').each(function(){
		initRequiredSelect(this, $(this).data('required-if'), false);
	});
});
